import BaseAPI from "../base";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";
// import hisService from "@/apis/his/index";

class BookingService extends BaseAPI {
  // HIS客户信息检索
  hisCustomerSearch(params) {
    return this.post({
      url: "/YuanHe/Book/HisCustomerSearch",
      data: params,
    });
  }

  // 客户列表
  customerList(params) {
    return this.post({
      url: "/YuanHe/Book/CustomerList",
      data: params,
    });
  }

  // 编辑客户信息
  customerEdit(params) {
    return this.post({
      url: "/YuanHe/Book/CustomerEdit",
      data: params,
    });
  }

  // HIS获取挂账公司列表
  hisCustomerCompanySearch(params) {
    return this.post({
      url: "/YuanHe/Book/HisCustomerCompanySearch",
      data: params,
    });
  }

  // 订单列表
  orderList(params) {
    return this.post({
      url: "/YuanHe/Book/OrderList",
      data: params,
    });
  }

  // 产品列表
  productList(params) {
    return this.post({
      url: "/YuanHe/Book/ProductList",
      data: params,
    });
  }

  // HIS套餐排班查询
  hisPlanSearch(params) {
    return this.post({
      url: "/YuanHe/Book/HisPlanSearch",
      data: params,
    });
  }

  // 新增预约申请
  applyAdd(params) {
    return this.post({
      url: "/YuanHe/Book/ApplyAdd",
      data: params,
    });
  }

  // 预约申请列表
  applyList(params) {
    return this.post({
      url: "/YuanHe/Book/ApplyList",
      data: params,
    });
  }

  //
  hisAddReference(params) {
    return this.post({
      url: "/YuanHe/Book/HisAddReference",
      data: params,
    });
  }

  // 订单详情
  applyInfo(params) {
    return this.post({
      url: "/YuanHe/Book/ApplyInfo",
      data: params,
    });
  }

  // HIS客户等级临时计算
  hisCustomerLevelTmpCal(params) {
    return this.post({
      url: "/YuanHe/Book/HisCustomerLevelTmpCal",
      data: params,
    });
  }

  // HIS套餐详情查询
  hisPackageSearch(params) {
    return this.post({
      url: "/YuanHe/Book/HisPackageSearch",
      data: params,
    });
  }

  // 客户详情
  customerInfo(params) {
    return this.post({
      url: "/YuanHe/Book/CustomerInfo",
      data: params,
    });
  }

  // 编辑支付订单
  orderEdit(params) {
    return this.post({
      url: "/YuanHe/Book/OrderEdit",
      data: params,
    });
  }

  // 订单详情
  getOrderInfo(params) {
    return this.post({
      url: "/YuanHe/Book/OrderInfo",
      data: params,
    });
  }

  // 获取客户标签项
  customerLabelList(params) {
    return this.post({
      url: "/YuanHe/Book/CustomerLabelList",
      data: params,
    });
  }

  // 预约车位检查
  applyParkingCheck(params) {
    return this.post({
      url: "/YuanHe/Book/ApplyParkingCheck",
      data: params,
    });
  }

  // 车位
  parkingGetList(params) {
    return this.get({
      url: `${process.env.VUE_APP_PARKING}`,
      data: params,
    });
  }

  // 消息列表
  messageList(params) {
    return this.post({
      url: `/YuanHe/Book/MessageList`,
      data: params,
    });
  }

  // 消息列表
  messageHistoryList(params) {
    return this.post({
      url: `/YuanHe/Book/MessageHistoryList`,
      data: params,
    });
  }

  // 消息标记已读
  messageMarkRead(params) {
    return this.post({
      url: `/YuanHe/Book/MessageMarkRead`,
      data: params,
    });
  }

  // 消息回复
  messageReply(params) {
    return this.post({
      url: `/YuanHe/Book/MessageReply`,
      data: params,
    });
  }

  // 预约列表
  bookReservationList(params) {
    return this.post({
      url: `/YuanHe/Book/BookReservationList`,
      data: params,
    });
  }

  // 修改预约
  bookReservationEdit(params) {
    return this.post({
      url: `/YuanHe/Book/BookReservationEdit`,
      data: params,
    });
  }

  // 取消预约
  bookReservationCancel(params) {
    return this.post({
      url: `/YuanHe/Book/BookReservationCancel`,
      data: params,
    });
  }

  // 机构回款列表
  returnedMoneyList(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/DingdingListV2`,
      data: params,
    });
  }
  // 机构回款详情V2
  dingdingDetailV2(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/DingdingDetailV2`,
      data: params,
    });
  }
  // 机构回款详情V2
  checkOcrTradeNo(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/CheckOcrTradeNo`,
      data: params,
    });
  }
  // 上传接口
  returnedMoneyEdit(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/DingdingEditV2`,
      data: params,
    });
  }
  // 上传检验接口
  returnedMoneyCheck(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/CheckOcrTradeNo`,
      data: params,
    });
  }
  //
  getDingdingDic(params) {
    return this.post({
      url: `/YuanHe/ReturnedMoney/DingdingDic`,
      data: params,
    });
  }
  // 上传接口
  getBookingList(params) {
    return this.post({
      url: `${process.env.VUE_APP_CALENDAR_APIBASEURL}/api/MenZhen/GetBookingList`,
      data: params,
    });
  }

  //
  hisReferenceList(params) {
    return this.post({
      url: `/YuanHe/Book/HisReferenceList`,
      data: params,
    });
  }

  //
  getUserIdByCode(params) {
    return this.get({
      url: `https://apihis.circleharmonyhospital.cn:5010/webdc/api/User/GetUserIdByCode_OldDingdingVersion`,
      params,
    });
  }

  // 相关枚举
  bookEnums() {
    return new Promise((resolve) => {
      let result = getStorageExpire(CONFIG_STORAGE.BOOKING_ENUM);

      if (result && result.version >= CONFIG_STORAGE.currentVersion)
        resolve(result);
      else {
        this.get({
          url: "/YuanHe/Book/GetBookEnum",
        }).then((res) => {
          console.log(res);
          Object.keys(res).forEach((key) => {
            const item = res[key];
            res[`${key}Arr`] = [];
            Object.keys(item).forEach((childKey) => {
              let value = childKey;
              if (isFinite(value)) {
                value = Number(value);
              }
              res[`${key}Arr`].push({
                value: Number(childKey),
                name: item[childKey],
              });
            });
          });
          setStorageExpire(
            CONFIG_STORAGE.BOOKING_ENUM,
            {
              ...res,
              version: CONFIG_STORAGE.currentVersion,
            },
            60 * 24
          );
          resolve(res);
        });
      }
    });
  }
}

export default new BookingService();
